import type { ReactNode } from 'react';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  tabs?: ReactNode;
}

/** The sticky white bar at the top of the content area — title, actions, tabs. */
export function PageHeader({ title, meta, actions, tabs }: PageHeaderProps): React.JSX.Element {
  return (
    <header className={styles.header}>
      <div className={styles.row}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>{title}</h1>
          {meta && <span className={styles.meta}>{meta}</span>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {tabs && <div className={styles.tabsRow}>{tabs}</div>}
    </header>
  );
}
